import axios from 'axios'
export default {
  name: 'Login',
  components: { },
  data () {
    return {
      ip: '', mail:'', pass: '', errores: [], regnombre: '', regcelular: '', avisos: [], cargando: '', cargandologin: ''
    }
  },
  mounted() {
  },
  methods: {
    vervideo(){
      $('#exampleModal').modal()
    },
    masinfo () {
      this.$router.push('/informacion')
    },
    logindeplaka: function () {
      if (this.verificarform() === true){
        this.enviarloginapi()
      }
    },
    iregrestro () {
      this.$router.push('/registro')
    },
    verificarform: function (event) {
      this.errores = []
      if (this.mail === '') {
        this.errores.push("Indique su Mail/Celular")
      }
      if (this.pass === ''){
        this.errores.push("Indique una contraseña")
      }
      if(!this.errores.length) {
        return true
      } else {
        return false
      }
    },
    enviarloginapi () {
      var empresa = this.$store.getters.url_empresa
      axios.get(this.$apibase+'gen/login/', {
        params: {
          "celular": this.mail, "pass": this.pass, "empresa": empresa
        }
      })
      .then( response => this.pasologinapi(response),  response => this.errorloginapi(response) )
      .catch( response => this.errorloginapi(response))
    },
    pasologinapi: function (respuesta) {
      if (respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales)
          this.$store.dispatch('SET_EMPRESAREFERIDA', respuesta.data.empresareferida)
          this.$router.push('/listador')
      } else {
        this.errorloginapi(respuesta)
      }
    },
    errorloginapi: function (respuesta) {
      if (respuesta.data.estado &&  respuesta.data.estado != 1){
        this.errores = []
        this.errores.push("Error en los datos enviados")
      }
    },
    registrodeplak: function (event) {
      if (this.verificarformreg() === true){
        this.cargando = 'Cargando....'
        event.preventDefault();
        event.stopPropagation();
        this.enviarregistroapi()
      }
    },
    verificarformreg: function (event) {
      this.avisos = []
      if (this.regnombre === '') {
        this.avisos.push("Indique su Nombre")
      }
      if (this.regcelular === '') {
        this.avisos.push("Indique su Celular")
      } else {
        if (this.verificarcelular(this.regcelular) === false) {
          this.avisos.push("Número de Celular no válido")
        }
      }
     
      if(!this.avisos.length) {
        return true
      } else {
        return false
      }
    },
    verificarcelular (actual) {
    var re = /(\d{3})(\d{3})(\d{3})/g;
    var nuevo = actual.replace(re, "$1$2$3");
    var codigo = actual.replace(re, "$1");
      
      if(codigo <= 99){
      switch(codigo) {
      case '091':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '092':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '093':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '094':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '095':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '096':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '097':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '098':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '099':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      default:
          return false;
  }
      }else{
          return false;
      }
    },
    enviarregistroapi () {
      let carpintero = []
      var empresa = this.$store.getters.url_empresa
      carpintero.push({'nombre': this.regnombre, 'tel': this.regcelular })  
      axios.post(this.$apibase+'gen/registro/', {
          "usuario": carpintero, 2006: 1, "empresa": empresa
      })
      .then( response => this.pasoregistroapi(response),  response => this.errorregistroapi(response) )
      .catch( response => this.errorregistroapi(response))
    },
    pasoregistroapi: function (respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales)
          this.$store.dispatch('SET_EMPRESAREFERIDA', respuesta.data.empresareferida)
          this.$router.push('/listador/1')
      } else {
        this.errorregistroapi(respuesta)
      }
    },
    errorregistroapi: function (respuesta) {
      if (respuesta.data.estado === 8) {
        this.avisos = []
        this.avisos.push("Ya tienes cuenta, enviamos un SMS con un link para acceder!")
      } else if (respuesta.data.estado &&  respuesta.data.estado != 1){
        this.avisos = []
        this.avisos.push("Error en los datos enviados")
      }
      this.cargando = ''
    },
    recuperarclave () {
      if (this.mail === '') {
        this.errores = []
        this.errores.push("Indique su Celular")
      } else {
        this.errores = []
        this.cargandologin = "Enviando SMS..."
        this.precuperacionclave()
      }
    },
    precuperacionclave () {
      axios.get(this.$apibase+'gen/recuperarclave/', {
        params: {
          "celular": this.mail
        }
      })
      .then( response => this.pasoprecuperacionclave(response),  response => this.errorprecuperacionclave(response) )
      .catch( response => this.errorprecuperacionclave(response))
    },
    pasoprecuperacionclave (response) {
      if (response.data.estado === 1) {
        Swal('SMS Enviado', 'Enviamos un SMS con un link para acceder!', 'success')
        this.cargandologin = ''
      } else{
        Swal('Error...', 'No pudimos enviar el SMS,verifica el telefono', 'error')
        this.cargandologin = ''
      }
    },
    errorprecuperacionclave (response) {

    }
  },
  computed: {
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/login.js